import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule, Type, ModuleWithProviders } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { AgentAssistantModule } from '@nimbus-library/features/agent-assistant/agent-assistant.module';
import { IMenuAuthService } from '@nimbus-library/features/menu/services/contracts/i-menu-auth.service';
import { IMenuProviderService } from '@nimbus-library/features/menu/services/contracts/i-menu-provider.service';
import { ITitleProviderService } from '@nimbus-library/features/menu/services/contracts/i-title-provider.service';
import { LocalizationModule } from '../localization/localization.module';
import { ModalModule } from '../modal/modal.module';
import { ModalLocalService } from '../modal/services/modal.local-service';
import { NavigationModule } from '../navigation/navigation.module';
import { SharedUIModule } from '../shared/shared.ui.module';
import { CompanionMenuItemComponent } from './components/companion-menu-item/companion-menu-item.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MenuOverflowItemComponent } from './components/menu-overflow-item/menu-overflow-item.component';
import { NimbusMenuComponent } from './components/nimbus-menu/nimbus-menu.component';
import { MenuState } from './state/menu.state';

@NgModule({
  declarations: [NimbusMenuComponent, MenuItemComponent, CompanionMenuItemComponent],
  imports: [
    NavigationModule,
    NgxsModule.forFeature([MenuState]),
    RouterModule.forChild([]),
    LocalizationModule,
    CommonModule,
    SharedUIModule,
    OverlayModule,
    ModalModule,
    MatDialogModule,
    AgentAssistantModule,
    MenuOverflowItemComponent,
  ],
  exports: [NimbusMenuComponent],
})
export class MenuModule {
  public static forRoot(
    menuProviderService: Type<IMenuProviderService>,
    menuAuthService: Type<IMenuAuthService>,
    titleProviderService: Type<ITitleProviderService>,
  ): ModuleWithProviders<MenuModule> {
    return {
      ngModule: MenuModule,
      providers: [
        ModalLocalService,
        { provide: IMenuProviderService, useClass: menuProviderService },
        { provide: IMenuAuthService, useClass: menuAuthService },
        { provide: ITitleProviderService, useClass: titleProviderService },
      ],
    };
  }
}
